<div class="full">
  <p [hidden]="noData" class="no-data no-data-available">{{ "SHARED.No_Data" | translate }}</p>
  <!-- <canvas id="wordCloud" width="1000" height="800"></canvas>
   -->
  <div style="text-align: center !important; height: 100%">
    <div height="800" id="my_container" width="1000"></div>
    <canvas height="800" id="my_canvas" style="display:none" width="1000"></canvas>
  </div>
</div>
